import React from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import humanizeString from "humanize-string";
import { string, object } from "prop-types";

class SetDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disbled: false,
      date: moment().add(15, "days")
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  handleChange(date) {
    this.setState({
      date: date
    });
  }

  handleConfirmation() {
    this.props.success(this.state.date);
  }

  render() {
    let { show, cancel, label } = this.props;
    return (
      <Modal show={show}>
        <Modal.Header closeButton>
          <Modal.Title>{humanizeString(label)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix">
          <p>Escolha a {label}</p>
          <DatePicker
            selected={this.state.date}
            onChange={this.handleChange}
            minDate={moment().add(1, "days")}
            className="form-control"
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-link"
            onClick={() => {
              cancel();
            }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            disabled={this.state.disabled}
            onClick={() => {
              this.handleConfirmation();
            }}
          >
            Definir {label}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SetDateModal.defaultProps = {
  label: "Data"
};

SetDateModal.propTypes = {
  label: string.isRequired
};

export default SetDateModal;



// WEBPACK FOOTER //
// ./src/components/modals/SetDateModal.js